const Icon = ({ icon, className }) => {
	return <img alt="" className={"icon "+className} src={`${window.PUBLICATION_DATA_URL}icons/${icon}.svg`} />
}

export default Icon;
